import { h } from "omi";

import { IconProps } from "../icons.ts";

export function TrophyIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 24 24">
      <path
        d="M12 15c-3.31371 0-6-2.6863-6-6V3.44444c0-.41384 0-.62077.06031-.78646.1011-.27777.3199-.49657.59767-.59767C6.82367 2 7.0306 2 7.44444 2h9.11116c.4138 0 .6207 0 .7864.06031.2778.1011.4966.3199.5977.59767C18 2.82367 18 3.0306 18 3.44444V9c0 3.3137-2.6863 6-6 6Zm0 0v3m6-14h2.5c.4659 0 .6989 0 .8827.07612.245.10149.4397.29617.5412.5412C22 4.80109 22 5.03406 22 5.5V6c0 .92997 0 1.39496-.1022 1.77646-.2774 1.03527-1.0861 1.84392-2.1213 2.12132C19.395 10 18.93 10 18 10M6 4H3.5c-.46594 0-.69891 0-.88268.07612-.24503.10149-.43971.29617-.5412.5412C2 4.80109 2 5.03406 2 5.5V6c0 .92997 0 1.39496.10222 1.77646.2774 1.03527 1.08605 1.84392 2.12132 2.12132C4.60504 10 5.07003 10 6 10m1.44444 12h9.11116c.2454 0 .4444-.199.4444-.4444C17 19.5919 15.4081 18 13.4444 18h-2.8888C8.59188 18 7 19.5919 7 21.5556c0 .2454.19898.4444.44444.4444Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
